import Table, { SORTER_STRING } from '../components/Table';
import { BrandBadge } from '../brands';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';
import DriverConfirmationIndicator from '../components/DriverConfirmationIndicator';



function UpcomingJobsTable({  }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const brandFilter = useSelector((state) => state.shownData.brandFilter);
    const data = common.filterByBrand(useSelector((state) => state.shownData.upcomingJobs), brandFilter);
    const sortedData = [...data].sort((a, b) => {
        return a["query_start"] > b["query_start"] ? 1 : -1;
    });

    useEffect(() => {
        dispatch(fetch.upcomingJobs());
    }, []);



    return (
        <Table
            style={{ width: '100%' }}
            columnNames={[
                "Reisi kuupäev",
                "Firma",
                "Sihtkohad",
                "Reisijad",
                "Vahemaa",
                "Maksumus",
                "Juht",
                "Reisi nr",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/job/" + row["query_id"])}>{common.displayDepart(row)}</a>),
                (row) => (<p>{row["query_brand"] === "triobuss" && <><BrandBadge brand={row["query_brand"]} />&nbsp;</>}{row["query_company"] || (<i style={{ color: "#668" }}>{row["query_fullname"]}</i>)}</p>),
                (row) => (<p style={{ maxWidth: 192, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{common.displayPrettyRoute(row)}</p>),
                (row) => (<p>{row["query_passengers"]}</p>),
                (row) => (<p>{common.displayDistance(row)}</p>),
                (row) => (<p>{common.displayPrice(row["query_response_price"])}</p>),
                (row) => {
                    const drivers = common.getJobDriversWithStatus(row);
                    if(!drivers.length) return (<p>-</p>);
                    return (
                        <p>
                            {drivers.map((driver, index) => (
                                <span key={driver.id} style={{ whiteSpace: 'nowrap' }}>
                                    {index > 0 ? ", " : ""}
                                    {driver.name} <DriverConfirmationIndicator status={driver.status} />
                                </span>
                            ))}
                        </p>
                    );
                },
                (row) => (<p>{row["job_sequential_id"]}</p>),
            ]}
            columnSorters={[
                (a, b) => common.sortDepart(a, b),
                ({ query_company: a }, { query_company: b }) => SORTER_STRING(a, b),
                null,
                null,
                null,
                ({ query_response_price: a }, { query_response_price: b }) => (+a) - (+b),
                ({ driver_firstname: a }, { driver_firstname: b }) => SORTER_STRING(a, b),
                ({ job_sequential_id: a }, { job_sequential_id: b }) => (+a) - (+b),
            ]}
            data={sortedData}
        />
    );
}

export default UpcomingJobsTable;